import React from "react";
import BackgroudImage from "../assets/images/bg/3.jpg";
import { useTranslation } from "react-i18next";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

export default function EcommerceBanner() {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <section
          style={{ backgroundImage: `url(${BackgroudImage})` }}
          className="py-16 lg:py-16 w-full table relative bg-center bg-cover pl-5"
          id="home"
        >
          <div className="absolute inset-0 bg-black opacity-80"></div>
          <div className="container relative">
            <div className="grid grid-cols-1 mt-12 flex justify-between">
              <div className="">
                <h4 className="text-white lg:text-4xl text-3xl font-medium mb-7 flex">
                  <i>
                    {t("providing_brilliant")}{" "}
                    <ArrowRightOutlined
                      style={{ color: "#8080ff", fontStyle: "bold" }}
                    />{" "}
                    <b className="text-[#8080ff] pr-2">{t("e_commerce")}</b>{" "}
                  </i>
                  <div className="ml-3 border"></div>
                  <div className="flex flex-col ml-3 text-orange-400 text-2xl">
                    <Link to="/solutions/SalesForecasting" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("sales_forecasting")} </Link>
                    <Link to="/solutions/MarketBasketAnalysis" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("market_basket_analysis")}  </Link>
                    <Link to="/solutions/CustomerBehaviorAnalysis" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("customer_behavior_analysis")} </Link>
                    <Link to="/solutions/RecommenderSystems" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("recommender_systems")} </Link>
                    <Link to="/solutions/LoyaltyProgramDevelopment" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("loyalty_program_development")} </Link>
                    <Link to="/solutions/CustomerChurnAnalysis" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("customer_churn_analysis")} </Link>
                    {/* <p>{t("store_optimization")}</p>
                        <p>{t("marketing_automation")}</p>
                        <p>{t("campaign_optimization")}</p> */}
                  </div>
                </h4>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
